import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
import { KeHoachHangVeDataSource } from '../ke-hoach-hang-ve-datasource/ke-hoach-hang-ve.datasource';
//Service
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { KeHoachHangVeTTHVService } from '../ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
import { environment } from '../../../../../../../environments/environment';
//Model
import { KeHoachHangVe } from '../../../mua-hang/ke-hoach-hang-ve/ke-hoach-hang-ve-model/ke-hoach-hang-ve.model';
//Component

import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';

@Component({
	selector: 'm-ke-hoach-hang-ve-ver2-list-dialog',
	templateUrl: './ke-hoach-hang-ve-ver2-list-dialog.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})
export class KeHoachHangVeListVer2DialogComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;

	// Table fields
	dataSource: KeHoachHangVeDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 2,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'NgayDeNghiGiaoHang',
            displayName: 'Ngày đề nghị giao hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 4,
            name: 'MaHang',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 5,
            name: 'TenHang',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoLuong',
            displayName: 'SLKH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoPhieuDNMH',
            displayName: 'Số phiếu ĐNMH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoPhieuDH',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true
		},
		
		
		{
            stt: 10,
            name: 'MaNCC',
            displayName: 'Mã NCC',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'TenNCC',
            displayName: 'Nhà cung cấp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		
	];

	@ViewChildren('focus') focus ;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild('searchFullText', {static: true}) searchFullText: ElementRef;

	// Filter fields
	@ViewChild('keywordSearch', {static: true}) keywordSearch: ElementRef;
	@ViewChild('searchTuNgay', {static: true}) searchTuNgay: ElementRef;
	@ViewChild('searchDenNgay', {static: true}) searchDenNgay: ElementRef;
	minDate: string = "";
	maxDate: string = "";

	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KeHoachHangVe>(true, []);

	KeHoachHangVeResult: KeHoachHangVe[] = [];
	tmpKeHoachHangVeResult: KeHoachHangVe[] = [];

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	thongTinHangVeItem: KeHoachHangVe[] = [];

	/* Extend field:  */
	previousIndex: number;
	fixedPoint = 2;
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	/* ------------------------------------------------------------------ */
	
	//ROLES
	TAO = 131;
	LIST_ROLES_USER : [] = [];
	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};

	constructor(
		public dialogRef: MatDialogRef<KeHoachHangVeListVer2DialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private keHoachHangVeService: KeHoachHangVeTTHVService,
		private thongTinHangVeService: ThongTinHangVeService,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private tokenStorage: TokenStorage,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
			this.dialogRef.disableClose = true;
		}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.haveFilter = true;

		if(this.data.data.length > 0){
			this.data.data.forEach(element => {
				
				let tmp = new KeHoachHangVe();
				tmp.copy(element);
				this.thongTinHangVeItem.push(tmp)
			});
		}
		
		this.showColumnsInTable();
		this.applySelectedColumns();

		// // If the PhieuThongTinHangVeTmp changes the sort order, reset back to the first page.
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		/* Data load will be triggered in two cases:
		- when a pagination event occurs => this.paginator.page
		- when a sort event occurs => this.sort.sortChange
		**/
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadKeHoachHangVeList();
				})
			)
			.subscribe();

		// Init DataSource
		this.dataSource = new KeHoachHangVeDataSource(this.keHoachHangVeService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			this.KeHoachHangVeResult = res
			this.tmpKeHoachHangVeResult = []
			if(this.KeHoachHangVeResult != null){
				for(let i = 0; i < this.KeHoachHangVeResult.length; i++){
					let tmpElement = new KeHoachHangVe();
					tmpElement.copy(this.KeHoachHangVeResult[i])
					this.tmpKeHoachHangVeResult.push(tmpElement);
				}
			}
		});
		this.loadKeHoachHangVeList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back(true);
			}
		});
	}
	ngAfterViewInit() {
	}
	loadKeHoachHangVeList() {
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadKeHoachHangVe(queryParams);
	}

	loadKeHoachHangVeListInit() {
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadKeHoachHangVe(queryParams);
	}

	filterConfiguration(): any {
		const filter: any = {};
		filter.FullSearch = this.searchFullText.nativeElement.value;
		return filter;
	}
	setDisabled(item: any){
		let _index = this.data.data.findIndex(x => x.Id == item.Id);
		if(_index > -1)
			return true;
		return false;
	}
	isChecked(item: any){
		let _index = this.thongTinHangVeItem.findIndex(x => x.Id == item.Id);
		if(_index > -1)
			return true;
		return false;
	}
	/* -----------------------------------------------------------------------*/

	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(close: boolean){
		this.dialogRef.close(
			{ 
				dataAdd : close ? null :this.selection.selected 	//highlight ID
			}
		);
	}
	/*------------------------------------------------------------- */

	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
    ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
    formatNumber(item: string){
        if(item == '' || item == null || item == undefined)	return '';
        return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
    }
    f_currency(value: string): any {
        if (value == null || value == undefined || value == '') value = '0.00';
        let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
        return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
    }
    f_currency_V2(value: string): any {
        if (value == null || value == undefined || value == '') return '';
        let nbr = Number((value + '').replace(/,/g, ""));
        return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    /* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
    getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
    }
    f_convertDate(p_Val: any) {
        if(p_Val == null || p_Val == undefined || p_Val == '') return '';
        let a = p_Val === "" ? new Date() : new Date(p_Val);
        return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, flag?: number) {
		if (flag == 0) //tu ngay dang selected
			this.minDate = this.f_convertDate(p_Val._d);
		else
			this.maxDate = this.f_convertDate(p_Val._d);
		let d1 = new Date(this.minDate);
		let d2 = new Date(this.maxDate);
		if (d1.getTime() > d2.getTime())
			this.maxDate = this.f_convertDate(d1.getDate() + 1);

		this.loadKeHoachHangVeList();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
    /* -----------------------------------------------------------------------*/


	/* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU --------------------------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		let countLengthData = 0;
		this.KeHoachHangVeResult.forEach(element =>{
			if(this.data.data.findIndex(x => x.Id == element.Id) > -1){
				countLengthData++;
			}
		})
		const numRows = this.KeHoachHangVeResult.length - countLengthData;
		return numSelected === numRows;
	}
	masterToggle() {
		
		if (this.isAllSelected()) {
			this.selection.clear();
			this.thongTinHangVeItem = [];
			this.data.data.forEach(element => {
				let tmp = new KeHoachHangVe();
				tmp.copy(element);
				this.thongTinHangVeItem.push(tmp)
			});
		} else {
			for(let i = 0; i < this.KeHoachHangVeResult.length; i++){
				let _index = this.thongTinHangVeItem.findIndex(x => x.Id == this.KeHoachHangVeResult[i].Id)
				if(_index == -1){
					this.selection.select(this.KeHoachHangVeResult[i])
					this.thongTinHangVeItem.push(this.KeHoachHangVeResult[i]);
				}
			}
		}
	}
	/*----------------------------------------------------------------------- */


	/*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable(){
        for(let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].isShow == false){
                this.selectedColumns.toggle(this.availableColumns[i]);
            }
        }
    }
    findIndexColumn(column: string){
        for( let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].name == column)
                return i;
        }
    }
    dragStarted(event: CdkDragStart, column: string) {
        this.previousIndex = this.findIndexColumn(column);
    }
    dropListDropped(event: CdkDropList, column: string) {
        if (event) {
            moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
            this.applySelectedColumns();
        }
    }
    applySelectedColumns() {
        let _selectedColumns = this.selectedColumns.selected;
        this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        for(let i = 0; i < this.availableColumns.length; i++){
            this.selectedColumns.toggle(this.availableColumns[i]);
            for( let j = 0; j < _selectedColumns.length; j++){
                if( this.availableColumns[i].name == _selectedColumns[j].name){
                    this.selectedColumns.toggle(this.availableColumns[i]);
                    break;
                }
            }
        }
        const _applySelectedColumns: string[] = [];
        this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
        this.displayedColumns = _applySelectedColumns;
    }
    /*----------------------------------------------------------------------- */
}
